import React           from 'react';
import maBaatarHe      from '../../images/ma_baatar.jpg';
import maBaatarAr      from '../../images/ma_baatar_ar.jpg';
import colors          from '../../utils/colors';
import { makeStyles }  from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    container: {
      position:     'absolute',
      left:         0,
      overflowY:    'scroll',
      overflowX:    'hidden',
      borderTop:    '1px solid #DDD',
      transition:   'all 0.8s',
      '&::-webkit-scrollbar': {
        width: '0.5em',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: colors.dark,
        borderRadius:    10
      }
    },
    image: {
      backgroundColor:    `#FFF`,
      marginRight:        '50%',
      transform:          'translate(50%, 0)',
      width:              '100%',
      backgroundSize:     'contain',
      backgroundPosition: 'top',
      backgroundRepeat:   'no-repeat'
    }
}))

type AboutProps = {
  size:           number[];
  navbarSize:     number;
  wideScreen:     boolean;
  lang:           string;
}

const About: React.FC<AboutProps> = ({
  size,
  navbarSize,
  wideScreen,
  lang
}) => {

  const classes = useStyles();

  const [initialPos, setInitialPos] = React.useState(false)

  React.useEffect(() => {
    setTimeout(() => { setInitialPos(true) },10)
  },[])

  const [containerStyle, imageStyle] = React.useMemo(() => {

    const width  = wideScreen ? size[0] - navbarSize : size[0];

    return [
        {
           width:  width,
           height: size[1] - 200,
           top:    initialPos ? 200 : '100vh'
        },
        {
           width:           width - 10,
           height:          size[0] > 800 ? 1000 : 600,
           backgroundImage: `url(${ lang === 'heb' ? maBaatarHe : maBaatarAr })`,
          // border: '5px solid #F00'
        }
    ]
  },[size, wideScreen, navbarSize, lang, initialPos])

  return (
         <div 
            className = { classes.container }
            style     = { containerStyle }
            dir       = 'rtl'
         >
            <div 
              className = { classes.image }
              style     = { imageStyle }
            />
         </div>
  );
}

export default About;





